import { useTranslation } from "react-i18next";
import { FiMinus } from "react-icons/fi";

type TimePeriodInputProps = {
  index: number;
  timePeriod: { start: string; end: string };
  onTimeChange: (index: number, type: "start" | "end", value: string) => void;
  onRemove?: (dayIndex: number, periodIndex: number) => void;
  isDisabled: boolean;
  isParent: boolean;
  dayIndex: number;
};

const TimePeriodInput = ({
  index,
  timePeriod,
  onTimeChange,
  onRemove,
  isDisabled,
  isParent,
  dayIndex
}: TimePeriodInputProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2">
      {/* Time Range Container */}
      <div className="flex flex-1 flex-col items-center gap-2 sm:flex-row">
        {/* Start Time */}
        <div className="relative flex-1">
          <input
            type="time"
            value={timePeriod.start}
            disabled={isDisabled}
            onChange={(e) => onTimeChange(index, "start", e.target.value)}
            className="w-full rounded-lg border border-gray-300 p-2 text-xs sm:text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        {/* Separator */}
        <span className="hidden text-sm text-gray-500 sm:block">
          {t("timePeriodInput.to")}
        </span>
        <span className="text-xs text-gray-500 sm:hidden">
          {t("timePeriodInput.to")}
        </span>

        {/* End Time */}
        <div className="relative flex-1">
          <input
            type="time"
            value={timePeriod.end}
            disabled={isDisabled}
            onChange={(e) => onTimeChange(index, "end", e.target.value)}
            className="w-full rounded-lg border border-gray-300 p-2 text-xs sm:text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>
      </div>

      {/* Remove Button - Only show if not parent */}
      {!isParent && (
        <button
          type="button"
          onClick={() => onRemove && onRemove(dayIndex, index)}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-600 transition-colors duration-200 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-300 sm:h-8 sm:w-8"
          aria-label={t("common.remove")}
        >
          <FiMinus className="h-3 w-3 sm:h-4 sm:w-4" />
        </button>
      )}
    </div>
  );
};

export default TimePeriodInput;
